import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

import type { EngagementReportBuilder2ReportRunResult } from "./types";

export const isEngagementReportBuilder2ReportRunResult = objectOf<EngagementReportBuilder2ReportRunResult>({
  success: boolean,
});
